import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./components/Login";
import Signup from "./components/Signup";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dashboard from "./components/Dashboard";
import Schedules from "./components/Schedules";
import Students from "./components/Students";
import Classes from "./components/Classes";
import AttendanceList from "./components/AttendanceList";
import BioLinks from "./components/BioLinks";
import PaymentControl from "./components/PaymentControl";
import StudentEvaluation from "./components/StudentEvaluation";
import StudentSelector from "./components/StudentSelector";
import StudentArea from "./components/StudentArea";
import ProtectedRoute from "./components/ProtectedRoute";

const App = () => {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<BioLinks />} />
          <Route path="/admin" element={<Login />} />
          <Route path="/register" element={<ProtectedRoute><Signup /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/my-schedules" element={<ProtectedRoute><Schedules /></ProtectedRoute>} />
          <Route path="/students" element={<ProtectedRoute><Students /></ProtectedRoute>} />
          <Route path="/classes" element={<ProtectedRoute><Classes /></ProtectedRoute>} />
          <Route path="/attendance-list" element={<ProtectedRoute><AttendanceList /></ProtectedRoute>} />
          <Route path="/payment-control" element={<ProtectedRoute><PaymentControl /></ProtectedRoute>} />
          <Route path="/student-evaluation" element={<ProtectedRoute><StudentEvaluation /></ProtectedRoute>} />
          <Route path="/student-selector" element={<ProtectedRoute><StudentSelector /></ProtectedRoute>} />
          <Route path="/student-area" element={<StudentArea />} />
        </Routes>
      </BrowserRouter>
      <ToastContainer />
    </div>
  );
};

export default App;
